import Map from "../Map/Map";

import React from "react"

function Dashboard() {

    return (
        <>
            <Map />
        </>
    );
}

export default Dashboard;
